import { ReactComponent as RuvitlLogo } from "../../icons/RUVITL.svg";
export default function RuvnlHeading({ title }: { title: string }) {
  return (
    <div className="header flex items-center justify-between">
      <h1>{title}</h1>
      <div className="flex flex-row justify-center items-center space-x-2 ">
        <RuvitlLogo width={"40px"} height={"60px"} />
        <h1>RUVITL Power Analytics Center</h1>
      </div>
    </div>
  );
}
export function RuvnlTitle() {
  return (
    <div className="flex flex-row justify-center items-center space-x-2 ">
      <RuvitlLogo width={"40px"} height={"60px"} />
      <h1 className="text-[#6F6D7C] text-[18px]">
        RUVITL Power Analytics Center
      </h1>
    </div>
  );
}

interface FooterProps {
  source: string;
  note: string;
}

export const GnaRuvnlFooter: React.FC<FooterProps> = ({ source, note }) => {
  return (
    <div className="gna-footer-container">
      <div className="flex justify-between">
        <p className="gna-footer-text">{source}</p>
        <p className="gna-footer-text col-span-1 text-center">
          Powered by <strong>GNA Energy</strong>
        </p>
        {/* <p className="gna-footer-text">Beta Version</p> */}
      </div>
      <p className="gna-footer-note">{note}</p>
      <p className="gna-footer-note">
        MW = Represents the average (MW) based on the selected time interval
        (Date or Month).
      </p>
    </div>
  );
};
